import styled from 'styled-components';
import Link from 'next/link';
import { colors, breakPoints, mixins } from '@/styles';

export const Navigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
  gap: 40px;
  border-bottom: 1px solid ${colors.secondary.lightGray3};
  @media (max-width: ${breakPoints.mobilePortrait}) {
    gap: 20px;
  }
`;

export const NavigationLink = styled(Link)<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
  color: ${({ $selected }) => ($selected ? colors.primary.black : colors.secondary.darkGray1)};

  padding: 20px 0;
  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: transparent;
  border-image: ${({ $selected }) => ($selected ? mixins.oxenBorderImageGradient : 'none')};
`;
